import React from 'react';
import {Background} from './my_stories_styles';
import {Button, LightButton} from "../../components/common_style/button";
import * as firebase from "firebase";
import AppBar from "../../components/app_bar";
import StoryGrid from "../../components/story_grid";
import {Routes} from "../../components/constants";
import {ButtonOutline} from "components/common_style/button";
import {Localization} from "localizations/languages";

function MyStories(props) {
    return <Background>
        <AppBar title={Localization.current.translation2} history={props.history} >
            <ButtonOutline onClick={() => props.history.replace(Routes.sharedStories)}>{Localization.current.translation3}</ButtonOutline>
        </AppBar>
        <StoryGrid history={props.history} shared={false}/>
    </Background>;
}

export default MyStories;